var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotMain = function SvgSpotMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0A",
    fillRule: "evenodd",
    d: "m13.19 14.03-3.392-3.392-3.392 3.392 3.392 3.392zm-4.696 0 1.304-1.303L11.1 14.03l-1.303 1.304z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.629 6.629a8.12 8.12 0 0 1 7.402-4.783 8.12 8.12 0 0 1 3.34 15.525 8.12 8.12 0 0 1-7.402 4.783 8.12 8.12 0 0 1-8.123-8.123c0-3.29 1.96-6.133 4.783-7.402M3.877 14.03a6.097 6.097 0 0 0 6.092 6.092 6.097 6.097 0 0 0 6.093-6.092 6.097 6.097 0 0 0-6.093-6.093 6.097 6.097 0 0 0-6.092 6.093m14.21.243-.005.244a6.08 6.08 0 0 0 2.041-4.549 6.097 6.097 0 0 0-6.092-6.092 6.06 6.06 0 0 0-4.55 2.04c.163-.01.326-.01.488-.01a8.12 8.12 0 0 1 8.123 8.124q0 .122-.005.243",
    clipRule: "evenodd"
  })));
};
export default SvgSpotMain;